import React from "react";

import FlowSvg from "../../assets/images/icons/flow.svg";

export const FlowIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={FlowSvg}
        alt={alt || "Flow"}
    />
);
